<template>
  <div class="shopping-cart">
    <div class="card">
      <div class="card-header">
        <span class="card-title">课程表</span>
      </div>
      <div class="action-bar">
        <el-button class="button" type="warning" size="mini" @click="clearCart"
          >清空课程表</el-button
        >
        <el-button
          class="delete-button"
          type="warning"
          size="mini"
          @click="deleteSelected"
          >选择删除</el-button
        >
      </div>
      <div class="card-body">
        <el-table
          ref="cartTable"
          center
          :data="cartItems"
          border
          :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="trainingTitle"
            label="课程信息"
            min-width="200"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="单价（元）"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span class="price">¥{{ scope.row.unitPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="数量"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            label="价格"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <span class="price"
                >¥{{ scope.row.unitPrice * scope.row.num }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="toDetails(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="cart-footer">
          <el-button class="button" type="warning" size="mini" @click="checkout"
            >提交审核</el-button
          >
          <!-- 已选课程：<span class="count">{{ cartItems.length }}</span> 门 -->
          <div class="flex-center">
            合计：<span class="total-price">¥{{ totalPrice }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cartList, deleteCart, review } from "@/api/course.js";
import { findRoute } from "@/utils/routerHelper.js";
export default {
  data() {
    return {
      selectedItems: [],
      cartItems: [],
    };
  },
  computed: {
    totalPrice() {
      return this.selectedItems.reduce((total, item) => {
        return total + parseInt(item.unitPrice) * parseInt(item.num);
      }, 0);
    },
  },
  created() {
    this.getCartList();
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedItems = selection;
    },
    delCart(ids) {
      deleteCart(ids).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data) {
            this.$message.success(
              ids.length == this.cartItems.length ? "课程表已清空" : "删除成功"
            );
            this.getCartList();
          } else {
            this.$message.error("删除失败，稍后再试");
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //清空课程表
    clearCart() {
      let that = this;
      if (this.cartItems.length === 0) {
        this.$message.warning("课程表已经是空的了");
        return;
      }
      this.$confirm("确定要清空课程表吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.delCart(this.cartItems.map((v) => v.cartId));
        })
        .catch(() => {});
    },
    //删除选中项
    deleteSelected() {
      let that = this;
      if (this.selectedItems.length === 0) {
        this.$message.warning("请先选择要删除的商品");
        return;
      }
      this.$confirm(
        `确定要删除选中的 ${this.selectedItems.length} 件商品吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          that.delCart(this.selectedItems.map((v) => v.cartId));
          // this.selectedItems.forEach(item => {
          //   const index = this.cartItems.indexOf(item)
          //   if (index > -1) {
          //     this.cartItems.splice(index, 1)
          //   }
          // })
          // this.selectedItems = []
          // this.$refs.cartTable.clearSelection()
          // this.$message.success('删除成功')
        })
        .catch(() => {});
    },
    getCartList() {
      cartList({
        current: 1,
        size: 10,
      }).then((res) => {
        if (res.data.code == 200) {
          this.cartItems = res.data.data.records.map((v) => {
            return {
              ...v.trainingDetail,
              unitPrice: v.unitPrice,
              num: v.num,
              cartId: v.id,
            };
          });
          this.total = res.data.data.total;
        }
      });
    },
    //查看课程详情
    toDetails(data) {
      this.$router.push({
        path: "/associationNews/courseDetails",
        query: { id: data.id },
      });
      let routerList = [];
      let routers = [
        "/personalCenter",
        "trainingSystemCart",
        "/associationNews/courseDetails",
      ];
      for (let i = 0; i < routers.length; i++) {
        let routerData = findRoute(this.$router.options.routes, routers[i]);
        routerList.push(routerData);
      }
      this.$store.commit("routerData/changeRouterList", routerList);
    },
    // 审核
    submit() {
      review({
        trainingIds: this.selectedItems.map((v) => v.id),
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data) {
            this.$message.success("提交审核成功");
            this.getCartList();
          } else {
            this.$message.error("提交审核失败，稍后再试");
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    removeItem(item) {
      this.$confirm(`确定要删除《${item.title}》吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const index = this.cartItems.indexOf(item);
          this.cartItems.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
    checkout() {
      if (this.cartItems.length === 0) {
        this.$message.warning("课程表为空");
        return;
      }
      if (this.selectedItems.length === 0) {
        this.$message.warning("请先选择要结算的课程");
        return;
      }
      let that = this;
      this.$confirm(
        `确定要提交审核 ${this.selectedItems.length} 门课程，合计 ¥${this.totalPrice} 吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        }
      )
        .then(() => {
          that.submit();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.shopping-cart {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }

    .action-bar {
      margin-bottom: 20px;
      display: flex;
      gap: 12px;
      .delete-button {
        background: #e4e4e4;
        border-radius: 7px;
        font-size: 14px;
        color: #666666;
        border: none;
        padding: 0 16px;
        line-height: 28px;
      }
    }

    .price {
      color: #ff6b00;
      font-weight: bold;
    }

    .cart-footer {
      margin-top: 20px;
      display: flex;
      align-items: center;
      padding-top: 20px;
      font-size: 14px;
      color: #333;
      gap: 16px;
      .count {
        color: #ff6b00;
        font-weight: bold;
        margin: 0 5px;
      }

      .total-price {
        color: #fc0a0a;
        font-size: 14px;
        font-weight: bold;
        // margin-left: 10px;
      }
    }
  }
  .button {
    background: #ed9d26;
    border-radius: 7px;
    font-size: 14px;
    color: #ffffff;
    border: none;
    padding: 0 16px;
    line-height: 28px;
  }
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ed9d26;
  border-color: #ed9d26;
}
::v-deep .el-checkbox_input.is-focus .el-checkbox_inner {
  border-color: #ed9d26 !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ed9d26;
  border-color: #ed9d26;
}

::v-deep .el-checkbox__inner:hover {
  border-color: #ed9d26;
}
</style>
